<script setup>
import { useField } from 'vee-validate'

const props = defineProps(['field', 'modelValue'])

const { value: model } = useField(
  () => props.field.clean_name,
  { required: props.field.required },
  {
    syncVModel: true,
  }
)

const options = props.field.choices?.length
  ? props.field.choices?.split('\r\n')
  : []
</script>

<template>
  <div class="box is-checklist">
    <b-radio
      v-for="item in options"
      v-model="model"
      :nativeValue="item"
      :name="field.clean_name"
    >
      {{ item }}
    </b-radio>
  </div>
</template>
